var servicePathData = {};
if( window._serviceEnv.toUpperCase() == 'RC' ){
	servicePathData = {
		plaync : 'http://rc.kr.plaync.com/',
		cs : 'https://rc-cs.plaync.com/',
		nshop : 'https://rc-bnsnshop.plaync.com/bns/',
		bns : 'https://rc-bns.plaync.com/',
		sandbox: 'https://rc-sandbox.plaync.com',
		esports : 'https://rc-bns.plaync.com/esports/main/',
		nctv : 'https://rc-nctv.plaync.com/',
		wstatic : 'https://rc-assets.playnccdn.com'
	}
} else {
	servicePathData = {
		plaync : 'http://kr.plaync.com/',
		cs : 'https://cs.plaync.com/',
		nshop : 'https://bnsnshop.plaync.com/bns/',
		bns : 'https://bns.plaync.com/',
		sandbox: 'https://sandbox.plaync.com',
		esports : 'https://bns.plaync.com/esports/main/',
		nctv : 'https://nctv.plaync.com/',
		wstatic : 'https://assets.playnccdn.com'
	};
	if (window._serviceEnv === 'SB') {
		servicePathData.bns = 'https://bns.sb.plaync.com/';
		servicePathData.wstatic = 'https://assets.sb.plaync.com';
	}
	if (window._serviceEnv === 'op') {
		servicePathData.bns = 'https://opdev-bns.plaync.com/';
		servicePathData.wstatic = ' https://op-assets.ncsoft.com';
	}

	if (location.href.match('local.bns.plaync.com:30454/')) {
		servicePathData.bns = "http://local.bns.plaync.com:30454/";
	}

	if (location.href.match('https://rwd-bns.plaync.com/')) {
		servicePathData.bns = "https://rwd-bns.plaync.com/";
	}

}

export const cnbConfig = {
  "type": "A",
  "bi": {
    "title": "Blade & Soul",
    "url": servicePathData.bns,
    "image": {
      top: {
        path : servicePathData.wstatic + "/uikit/cnb/v2/img/bi/bi-bnsneo-type1.png",
        style : {
          width: 90,
          height: 46,
          marginTop: 2
        }
      },
      lnb: {
        path: servicePathData.wstatic + "/uikit/cnb/v2/img/bi/bi-bnsneo-type2.png",
        style: {
          width: 90,
          height: 46,
          marginTop: 2
        }
      }
    }
  },
  "theme": {
    colorScheme: "bns"
  },
  "activeSubUrls": ["/search/"],
  "useLeftMenu": true,
  "useLoginMenu": true,
  "useJoinMenu": true,
  "useCs":true,
  "csUrl":"https://help.plaync.com/faq/bns",
  "useCharInfoOnlyServer": true,
  "useGameStart": "gameStart",
  "gameStart": {
    "markUp": "<a href='"+ servicePathData.bns + "download/index' class='ncc-gamestart-btn__start'>다운로드</a>"
  },
  "search": {
    "isShow": true,
    "destUrl": servicePathData.bns + "search/index",
    "queryPattern": "?",
    "service": "bns",
    "alias": "bns",
    "size": 10,
    "useDelbtn": true,
    "addParam": {},
    "useSearchV2": true
  },
  "lnbData": [
    {
      "title": "소식",
      "url": servicePathData.bns + "board/notice/home",
      "iconType": "new",
      "sub": [
        {
          "title": "공지",
          "url": servicePathData.bns + "board/notice/home",
          "iconType": "new",
          "otherUrls" : ["board/notice/", "board/neonotice/"]
        },
        {
          "title": "업데이트",
          "url": servicePathData.bns + "board/update/list",
          "otherUrls" : ["board/update/"]
        },
        {
          "title": "업데이트 연대기",
          "url": servicePathData.bns + "history/list"
        }
      ]
    },
    {
      "title": "NEO NEWS",
      "url": servicePathData.bns + "board/news/home",
      "otherUrls" : ["board/neonews/", "board/news/"]
    },
    {
      "title": "이벤트ON",
      "url": servicePathData.bns + "eventon"
    },
    {
      "title": "가이드",
      "url": servicePathData.bns + "guidebook/index",
      "iconType": "new",
      "sub": [
        {
          "title": "가이드북",
          "url": servicePathData.bns + "guidebook/index",
          "iconType": "new",
          "otherUrls" : ["guidebook"]
        },
        {
          "title": "PC방 혜택",
          "url": servicePathData.bns + "guide/pcbang"
        }
      ]
    },
    {
      "title": "블소월드",
      "url": servicePathData.bns + "world/character",
      "sub": [
        {
          "title": "서고",
          "url": servicePathData.bns + "board/library/list",
          "otherUrls" : ["board/library/"]
        },
        {
          "title": "캐릭터",
          "url": servicePathData.bns + "world/character",
          "otherUrls": ["world/chatlog"]

        },
        {
          "title": "문파",
          "url": servicePathData.bns + "world/guild",
          "otherUrls": ["world/guildpr"]
        }
      ]
    },
    {
      "title": "커뮤니티",
      "url": servicePathData.bns + "board/free/home",
      "sub": [
        {
          "title": "자유",
          "url": servicePathData.bns + "board/free/home",
          "otherUrls" : ["board/neofree/", "board/free/"]
        },
        {
          "title": "직업",
          "url": servicePathData.bns + "board/job/home",
          "otherUrls" : ["board/neojob/", "board/job/"]
        },
        {
          "title": "문파모집",
          "url": servicePathData.bns + "board/member_recruit/list",
          "otherUrls" : ["board/member_recruit/"]
        },
        {
          "title": "이미지",
          "url": servicePathData.bns + "board/image/home",
          "otherUrls" : ["board/neoimage/", "board/image/"]
        }
      ]
    },
    {
      "title": "블소샵",
      "url": servicePathData.nshop
    },
    {
      "title": "NCTV",
      "url": servicePathData.nctv + "?tv=bns",
      "iconType": ( _device == "launcher") ? "external" : "false",
      "sub": [
        {
          "title": "NCTV 메인",
          "url": servicePathData.nctv + "?tv=bns"
        },
        {
          "title": "인기영상",
          "url": servicePathData.nctv + "top?tv=bns"
        },
        {
          "title": "최신영상",
          "url": servicePathData.nctv + "recent?tv=bns"
        },
        {
          "title": "라이브",
          "url": servicePathData.nctv + "live?tv=bns"
        },
        {
          "title": "공략영상",
          "url": servicePathData.nctv + "attack/index?tv=bns"
        },
        {
          "title": "공식영상",
          "url": servicePathData.nctv + "official?tv=bns"
        },
        {
          "title": "e스포츠영상",
          "url": servicePathData.nctv + "esports?tv=bns"
        },
        {
          "title": "OST영상",
          "url": servicePathData.nctv + "ost?tv=bns"
        }
      ]
    },
    {
      "title": "e스포츠",
      "url": servicePathData.bns + "esports/esportsvod/list",
      "iconType": "false",
      "sub": [
        {
          "title": "동영상",
          "url": servicePathData.bns + "esports/esportsvod/list",
        },
        {
          "title": "시즌 연대기",
          "url": servicePathData.bns + "esports/history",
        },
      ]
    }
  ],
  "shortCut": {
    "isShow": true,
    "mypage": {
      "isShow": true,
    },
    "enterCoupon": {
      "isShow": true
    },
    "ncoin": {
      "isShow": false,
      "url": servicePathData.ncoin,
      "type": "popup",
      "popOption": "width=480,height=650,toolbar=0,menubar=0",
      "popupName": "ncoinPopup"
    },
    "cs": {
      "isShow": true,
      "type": "false",
      "popOption": "",
      "popupName": ""
    }
  },
  "serviceList": {
    "isServiceShow": true,
    "isGamesShow": true,
    "services": {
      "Plaync": {
        "isShow": true,
        "url": "https://www.plaync.com/"
      },
      "NShop": {
        "isShow": false,
        "url": "https://nshop.plaync.com/"
      }
    }
  },
  "appDownload": {
    "isShow": false,
    "appList": []
  },
  "loginFN": "GNBLogin",
  "logoutFN": "GNBLogout",
  "useCharChangeMenu": true,
  "charChangeFN": "characterChange",
  "showAccountName": true
};